var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaticOracleCaseStudy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 680 410",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrow",
    viewBox: "0 0 10 10",
    refX: 8,
    refY: 5,
    markerWidth: 6,
    markerHeight: 6,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 1L8 5L2 9",
    fill: "none",
    stroke: "context-stroke",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "imagine-text-gaps-e7wdqb",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 680,
    height: 410,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.20200729370117,
    y: 22.611099243164062,
    width: 67.59598159790039,
    height: 16.75001335144043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 55.69442367553711,
    width: 150.61126708984375,
    height: 29.50002670288086,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 87.36109161376953,
    width: 271.2272644042969,
    height: 22.416685104370117,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.32571792602539,
    y: 146.66665649414062,
    width: 51.348567962646484,
    height: 18.16668128967285,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.27057647705078,
    y: 163.61109924316406,
    width: 87.45884704589844,
    height: 16.75001335144043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.91360092163086,
    y: 178.5555419921875,
    width: 62.17279815673828,
    height: 15.805567741394043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.9344482421875,
    y: 145.5555419921875,
    width: 50.13111877441406,
    height: 15.805567741394043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.4279022216797,
    y: 139.66665649414062,
    width: 109.14420318603516,
    height: 18.16668128967285,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.89645385742188,
    y: 157.5555419921875,
    width: 74.20709991455078,
    height: 15.805567741394043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.83763122558594,
    y: 171.5555419921875,
    width: 110.32476043701172,
    height: 15.805567741394043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.83090209960938,
    y: 185.5555419921875,
    width: 116.33821868896484,
    height: 15.805567741394043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.9515686035156,
    y: 145.5555419921875,
    width: 38.096818923950195,
    height: 15.805567741394043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.4903869628906,
    y: 146.66665649414062,
    width: 73.0191650390625,
    height: 18.16668128967285,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.8860168457031,
    y: 163.5555419921875,
    width: 80.22794342041016,
    height: 15.805567741394043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.8584289550781,
    y: 177.5555419921875,
    width: 98.2830810546875,
    height: 15.805567741394043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.941162109375,
    y: 145.5555419921875,
    width: 44.11766052246094,
    height: 15.805567741394043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 524.2669067382812,
    y: 146.66665649414062,
    width: 87.46623229980469,
    height: 18.16668128967285,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 521.868896484375,
    y: 163.5555419921875,
    width: 92.26223754882812,
    height: 15.805567741394043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 524.8756103515625,
    y: 177.5555419921875,
    width: 86.248779296875,
    height: 15.805567741394043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.8204345703125,
    y: 236.5555419921875,
    width: 122.35906219482422,
    height: 15.805567741394043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.979156494140625,
    y: 275.58331298828125,
    width: 20.04167938232422,
    height: 27.138912200927734,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.9344367980957,
    y: 300.5555419921875,
    width: 50.13111877441406,
    height: 15.805567741394043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.93748474121094,
    y: 275.58331298828125,
    width: 44.125038146972656,
    height: 27.138912200927734,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.84805297851562,
    y: 300.5555419921875,
    width: 104.30391693115234,
    height: 15.805567741394043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.9166259765625,
    y: 275.58331298828125,
    width: 56.166717529296875,
    height: 27.138912200927734,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.8688659667969,
    y: 300.5555419921875,
    width: 92.26223754882812,
    height: 15.805567741394043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 491.9166259765625,
    y: 275.58331298828125,
    width: 56.166717529296875,
    height: 27.138912200927734,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470.85845947265625,
    y: 300.5555419921875,
    width: 98.2830810546875,
    height: 15.805567741394043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.511253356933594,
    y: 336.611083984375,
    width: 60.97748565673828,
    height: 16.75001335144043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.8241958618164,
    y: 336.611083984375,
    width: 54.35161209106445,
    height: 16.751771926879883,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.20199584960938,
    y: 336.611083984375,
    width: 67.59598159790039,
    height: 16.75001335144043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.2019958496094,
    y: 336.611083984375,
    width: 67.59598159790039,
    height: 16.75001335144043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.755615234375,
    y: 336.611083984375,
    width: 34.48874282836914,
    height: 16.75001335144043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.44635009765625,
    y: 336.611083984375,
    width: 41.10723876953125,
    height: 16.75001335144043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500.8927307128906,
    y: 336.611083984375,
    width: 74.2144775390625,
    height: 16.75001335144043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 372.611083984375,
    width: 458.2569885253906,
    height: 16.751771926879883,
    fill: "black",
    rx: 2
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 680,
    height: 400,
    rx: 12,
    fill: "#050008",
    style: {
      fill: "rgb(5, 0, 8)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 80,
    x2: 680,
    y2: 80,
    stroke: "#0d0020",
    strokeWidth: 0.5,
    mask: "url(#imagine-text-gaps-e7wdqb)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(13, 0, 32)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 160,
    x2: 680,
    y2: 160,
    stroke: "#0d0020",
    strokeWidth: 0.5,
    mask: "url(#imagine-text-gaps-e7wdqb)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(13, 0, 32)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 240,
    x2: 680,
    y2: 240,
    stroke: "#0d0020",
    strokeWidth: 0.5,
    mask: "url(#imagine-text-gaps-e7wdqb)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(13, 0, 32)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 320,
    x2: 680,
    y2: 320,
    stroke: "#0d0020",
    strokeWidth: 0.5,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(13, 0, 32)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 0,
    x2: 170,
    y2: 400,
    stroke: "#0d0020",
    strokeWidth: 0.5,
    mask: "url(#imagine-text-gaps-e7wdqb)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(13, 0, 32)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 0,
    x2: 340,
    y2: 400,
    stroke: "#0d0020",
    strokeWidth: 0.5,
    mask: "url(#imagine-text-gaps-e7wdqb)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(13, 0, 32)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 510,
    y1: 0,
    x2: 510,
    y2: 400,
    stroke: "#0d0020",
    strokeWidth: 0.5,
    mask: "url(#imagine-text-gaps-e7wdqb)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(13, 0, 32)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 20,
    width: 90,
    height: 22,
    rx: 4,
    fill: "#1a0035",
    style: {
      fill: "rgb(26, 0, 53)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 69,
    y: 35,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#ff2d78",
    fontFamily: "monospace",
    style: {
      fill: "rgb(255, 45, 120)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "WEB3 GAME"), /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 78,
    fontSize: 22,
    fill: "#ffffff",
    fontWeight: 600,
    fontFamily: "sans-serif",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 22,
      fontWeight: 600,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "MATIC Oracle"), /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 104,
    fontSize: 16,
    fill: "#7b2fff",
    fontWeight: 500,
    fontFamily: "sans-serif",
    style: {
      fill: "rgb(123, 47, 255)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 16,
      fontWeight: 500,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "On-Chain Prediction Game \xB7 Polygon"), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 138,
    width: 108,
    height: 52,
    rx: 6,
    fill: "#0a0010",
    stroke: "#ff2d78",
    strokeWidth: 0.8,
    style: {
      fill: "rgb(10, 0, 16)",
      stroke: "rgb(255, 45, 120)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.8px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 84,
    y: 160,
    textAnchor: "middle",
    fontSize: 12,
    fill: "#ff2d78",
    fontFamily: "monospace",
    style: {
      fill: "rgb(255, 45, 120)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Player"), /*#__PURE__*/React.createElement("text", {
    x: 84,
    y: 176,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#7a1040",
    fontFamily: "monospace",
    style: {
      fill: "rgb(122, 16, 64)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "MATIC wallet"), /*#__PURE__*/React.createElement("text", {
    x: 84,
    y: 190,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#5a0a30",
    fontFamily: "monospace",
    style: {
      fill: "rgb(90, 10, 48)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "SIWE auth"), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 164,
    x2: 178,
    y2: 164,
    stroke: "#ff2d78",
    strokeWidth: 1.2,
    markerEnd: "url(#arrow)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 45, 120)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "1.2px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 159,
    y: 157,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#7a1040",
    fontFamily: "monospace",
    style: {
      fill: "rgb(122, 16, 64)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "predict"), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 130,
    width: 130,
    height: 68,
    rx: 6,
    fill: "#0d0020",
    stroke: "#7b2fff",
    strokeWidth: 1,
    style: {
      fill: "rgb(13, 0, 32)",
      stroke: "rgb(123, 47, 255)",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 245,
    y: 153,
    textAnchor: "middle",
    fontSize: 12,
    fill: "#c084fc",
    fontFamily: "monospace",
    style: {
      fill: "rgb(192, 132, 252)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Smart Contract"), /*#__PURE__*/React.createElement("text", {
    x: 245,
    y: 169,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#7b2fff",
    fontFamily: "monospace",
    style: {
      fill: "rgb(123, 47, 255)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "round logic"), /*#__PURE__*/React.createElement("text", {
    x: 245,
    y: 183,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#7b2fff",
    fontFamily: "monospace",
    style: {
      fill: "rgb(123, 47, 255)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "scoring \xB7 rewards"), /*#__PURE__*/React.createElement("text", {
    x: 245,
    y: 197,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#5a1acc",
    fontFamily: "monospace",
    style: {
      fill: "rgb(90, 26, 204)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Solidity \xB7 Polygon"), /*#__PURE__*/React.createElement("line", {
    x1: 310,
    y1: 164,
    x2: 348,
    y2: 164,
    stroke: "#00f5ff",
    strokeWidth: 1.2,
    markerEnd: "url(#arrow)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 245, 255)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "1.2px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 329,
    y: 157,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#007a80",
    fontFamily: "monospace",
    style: {
      fill: "rgb(0, 122, 128)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "query"), /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 138,
    width: 118,
    height: 52,
    rx: 6,
    fill: "#001a1a",
    stroke: "#00f5ff",
    strokeWidth: 0.8,
    style: {
      fill: "rgb(0, 26, 26)",
      stroke: "rgb(0, 245, 255)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.8px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 409,
    y: 160,
    textAnchor: "middle",
    fontSize: 12,
    fill: "#00f5ff",
    fontFamily: "monospace",
    style: {
      fill: "rgb(0, 245, 255)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Chainlink"), /*#__PURE__*/React.createElement("text", {
    x: 409,
    y: 175,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#007a80",
    fontFamily: "monospace",
    style: {
      fill: "rgb(0, 122, 128)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "BTC/USD feed"), /*#__PURE__*/React.createElement("text", {
    x: 409,
    y: 189,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#004a50",
    fontFamily: "monospace",
    style: {
      fill: "rgb(0, 74, 80)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "real-time price"), /*#__PURE__*/React.createElement("line", {
    x1: 469,
    y1: 164,
    x2: 507,
    y2: 164,
    stroke: "#ffd700",
    strokeWidth: 1.2,
    markerEnd: "url(#arrow)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 215, 0)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "1.2px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 488,
    y: 157,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#806800",
    fontFamily: "monospace",
    style: {
      fill: "rgb(128, 104, 0)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "settle"), /*#__PURE__*/React.createElement("rect", {
    x: 509,
    y: 138,
    width: 118,
    height: 52,
    rx: 6,
    fill: "#1a1200",
    stroke: "#ffd700",
    strokeWidth: 0.8,
    style: {
      fill: "rgb(26, 18, 0)",
      stroke: "rgb(255, 215, 0)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.8px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 568,
    y: 160,
    textAnchor: "middle",
    fontSize: 12,
    fill: "#ffd700",
    fontFamily: "monospace",
    style: {
      fill: "rgb(255, 215, 0)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Leaderboard"), /*#__PURE__*/React.createElement("text", {
    x: 568,
    y: 175,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#806800",
    fontFamily: "monospace",
    style: {
      fill: "rgb(128, 104, 0)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "on-chain state"), /*#__PURE__*/React.createElement("text", {
    x: 568,
    y: 189,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#504000",
    fontFamily: "monospace",
    style: {
      fill: "rgb(80, 64, 0)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "MATIC rewards"), /*#__PURE__*/React.createElement("path", {
    d: "M568 190 Q568 230 84 230 Q84 210 84 192",
    fill: "none",
    stroke: "#00ff88",
    strokeWidth: 1,
    strokeDasharray: "4 3",
    markerEnd: "url(#arrow)",
    mask: "url(#imagine-text-gaps-e7wdqb)",
    style: {
      fill: "none",
      stroke: "rgb(0, 255, 136)",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeDasharray: "4px, 3px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 330,
    y: 248,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#00803a",
    fontFamily: "monospace",
    style: {
      fill: "rgb(0, 128, 58)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "reward distribution"), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 268,
    x2: 656,
    y2: 268,
    stroke: "#1a0035",
    strokeWidth: 0.5,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(26, 0, 53)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 296,
    textAnchor: "middle",
    fontSize: 20,
    fill: "#ff2d78",
    fontWeight: 600,
    fontFamily: "monospace",
    style: {
      fill: "rgb(255, 45, 120)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 20,
      fontWeight: 600,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "0"), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 312,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#7a1040",
    fontFamily: "monospace",
    style: {
      fill: "rgb(122, 16, 64)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "backend"), /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 296,
    textAnchor: "middle",
    fontSize: 20,
    fill: "#00f5ff",
    fontWeight: 600,
    fontFamily: "monospace",
    style: {
      fill: "rgb(0, 245, 255)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 20,
      fontWeight: 600,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "&lt;2s"), /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 312,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#007a80",
    fontFamily: "monospace",
    style: {
      fill: "rgb(0, 122, 128)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "round resolution"), /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 296,
    textAnchor: "middle",
    fontSize: 20,
    fill: "#7b2fff",
    fontWeight: 600,
    fontFamily: "monospace",
    style: {
      fill: "rgb(123, 47, 255)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 20,
      fontWeight: 600,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "100%"), /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 312,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#5a1acc",
    fontFamily: "monospace",
    style: {
      fill: "rgb(90, 26, 204)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "on-chain logic"), /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 296,
    textAnchor: "middle",
    fontSize: 20,
    fill: "#ffd700",
    fontWeight: 600,
    fontFamily: "monospace",
    style: {
      fill: "rgb(255, 215, 0)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 20,
      fontWeight: 600,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "live"), /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 312,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#806800",
    fontFamily: "monospace",
    style: {
      fill: "rgb(128, 104, 0)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Polygon mainnet"), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 334,
    width: 72,
    height: 22,
    rx: 4,
    fill: "#1a0035",
    style: {
      fill: "rgb(26, 0, 53)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 349,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#7b2fff",
    fontFamily: "monospace",
    style: {
      fill: "rgb(123, 47, 255)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Solidity"), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 334,
    width: 72,
    height: 22,
    rx: 4,
    fill: "#1a0035",
    style: {
      fill: "rgb(26, 0, 53)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 349,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#7b2fff",
    fontFamily: "monospace",
    style: {
      fill: "rgb(123, 47, 255)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Polygon"), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 334,
    width: 84,
    height: 22,
    rx: 4,
    fill: "#001a1a",
    style: {
      fill: "rgb(0, 26, 26)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 226,
    y: 349,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#00f5ff",
    fontFamily: "monospace",
    style: {
      fill: "rgb(0, 245, 255)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Chainlink"), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 334,
    width: 78,
    height: 22,
    rx: 4,
    fill: "#001a1a",
    style: {
      fill: "rgb(0, 26, 26)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 315,
    y: 349,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#00f5ff",
    fontFamily: "monospace",
    style: {
      fill: "rgb(0, 245, 255)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "ethers.js"), /*#__PURE__*/React.createElement("rect", {
    x: 362,
    y: 334,
    width: 60,
    height: 22,
    rx: 4,
    fill: "#001a1a",
    style: {
      fill: "rgb(0, 26, 26)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 392,
    y: 349,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#00f5ff",
    fontFamily: "monospace",
    style: {
      fill: "rgb(0, 245, 255)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "SIWE"), /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 334,
    width: 60,
    height: 22,
    rx: 4,
    fill: "#1a1200",
    style: {
      fill: "rgb(26, 18, 0)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 460,
    y: 349,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#ffd700",
    fontFamily: "monospace",
    style: {
      fill: "rgb(255, 215, 0)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "React"), /*#__PURE__*/React.createElement("rect", {
    x: 498,
    y: 334,
    width: 80,
    height: 22,
    rx: 4,
    fill: "#1a1200",
    style: {
      fill: "rgb(26, 18, 0)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 538,
    y: 349,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#ffd700",
    fontFamily: "monospace",
    style: {
      fill: "rgb(255, 215, 0)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Space Mono"), /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 385,
    fontSize: 11,
    fill: "#3a0060",
    fontFamily: "monospace",
    style: {
      fill: "rgb(58, 0, 96)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "prediction game \xB7 on-chain \xB7 no backend \xB7 chainlink oracle \xB7 polygon"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaticOracleCaseStudy);
export default __webpack_public_path__ + "static/media/matic-oracle-case-study.87b7f5220c1417f36fdd8a4f34a8ea4d.svg";
export { ForwardRef as ReactComponent };